import { required } from '@bpba/form-components';
import { ADDRESS_MAX_LENGTH, ADDRESS_MIN_LENGTH, INPUT_INVALID_FORMAT_MESSAGE, INTEGER_NUMBER_FORMAT, TELEPHONE_MAX_LENGTH, TELEPHONE_MIN_LENGTH } from '../constants/form';

const addressRules = {
  required,
  minLength: {
    message: `Debe tener al menos ${ADDRESS_MIN_LENGTH} caracteres`,
    value: ADDRESS_MIN_LENGTH,
  },
  maxLength: {
    message: `Debe tener hasta ${ADDRESS_MAX_LENGTH} caracteres`,
    value: ADDRESS_MAX_LENGTH,
  },
};

const telephoneRules = {
  required,
  minLength: {
    message: `Debe tener al menos ${TELEPHONE_MIN_LENGTH} dígitos`,
    value: TELEPHONE_MIN_LENGTH,
  },
  maxLength: {
    message: `Debe tener hasta ${TELEPHONE_MAX_LENGTH} dígitos`,
    value: TELEPHONE_MAX_LENGTH,
  },
  pattern: {
    message: INPUT_INVALID_FORMAT_MESSAGE,
    value: INTEGER_NUMBER_FORMAT,
  },
};

export const SignUpAddressRules = (addressRequired: boolean, telephoneRequired: boolean) => ({
  rules: {
    address: addressRequired ? addressRules : {},
    telephone: telephoneRequired ? telephoneRules : {},
    terms: { required },
  },
});
